<template>
  <div>
    <ResendConfirmationOptions
      v-if="showResendOptions"
      @chosenConfirmationOption="resendConfirmationCode"
    />

    <div v-else>
      <p class="body-regular gray-900 pt-24 mt-24 mb-24">
        Para prosseguir, insira o código enviado para o celular
        <span class="body-bold">{{ hiddenPhone }}</span>
      </p>

      <input-token
        :length="6"
        :status="verifyStatus"
        @complete="completedVerificationCode"
        @backspace="handleBackspace"
      />

      <div class="resend-text" v-if="!['loading', 'success'].includes(verifyStatus)">
        <a @click="handleShowResendOptions"
          :class="{ 'disabled': disableTheResendCounter || chosenConfirmationResendType }"
        >
          Não recebi o código {{ resendCounter !== 0 ? `(${resendCounter}s)` : '' }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import InputToken from '@/components/common/InputToken.vue';
import ResendConfirmationOptions from './ResendConfirmationOptions.vue';

export default {
  name: 'OnboardingConfirmationToken',
  data() {
    return {
      resendCounter: 90,
    };
  },
  props: {
    hiddenPhone: {
      type: String,
      required: true,
    },
    verifyStatus: {
      type: String,
    },
  },
  components: {
    InputToken,
    ResendConfirmationOptions,
  },
  computed: {
    ...mapState('onboardingV2', [
      'phone',
      'disableTheResendCounter',
      'showResendOptions',
      'confirmationResendType',
      'chosenConfirmationResendType',
    ]),
  },
  methods: {
    handleBackspace() {
      this.$emit('backspace');
    },
    async completedVerificationCode(securityCode) {
      this.$emit('completedVerificationCode', securityCode);
    },
    handleShowResendOptions() {
      if (!this.chosenConfirmationResendType) {
        this.setShowResendOptions({ showResendOptions: true });
      }
    },
    resendConfirmationCode() {
      if (this.resendCounter !== 0) return;
      this.resendCounter = 90;
      this.startResendCounter();
    },
    ...mapActions('onboardingV2', [
      'setShowResendOptions',
    ]),
    startResendCounter() {
      const resendInterval = setInterval(() => {
        this.resendCounter -= 1;
        if (this.resendCounter === 0) {
          clearInterval(resendInterval);
          this.setChosenConfirmationResendType();
        }
      }, 1000);
    },
    ...mapMutations('onboardingV2', [
      'setChosenConfirmationResendType',
      'setDisableTheResendCounter',
    ]),
  },
  mounted() {
    this.setChosenConfirmationResendType();
    this.startResendCounter();
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .resend-text {
    display: flex;
    justify-content: center;
    margin-top: 24px;

    a {
      @extend .body-regular;
      font-size: 16px;
      line-height: 24px;
      cursor: pointer;
      color: $primary-500;

      &:hover {
        color: $primary-600;
      }

      &.disabled {
        pointer-events: none;
        color: $gray-400;
      }
    }
  }
</style>
